import { Skeleton } from 'ui';
import { ContentObjectPreview } from '../../../../content-object-preview';
import { useContentObjectQuery } from '../../../../queries';

type P = {
  id: string;
};

const SharedContentObject = ({ id }: P) => {
  const { data: contentObject, isLoading } = useContentObjectQuery(id);

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 3 }} />;
  }

  if (!contentObject) {
    return null;
  }

  return <ContentObjectPreview item={contentObject} view="feed" />;
};

export default SharedContentObject;
